import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";

const AboutSection = lazy(() => import("@/components/AboutSection").then(m => ({ default: m.AboutSection })));
const HowItWorks = lazy(() => import("@/components/HowItWorks").then(m => ({ default: m.HowItWorks })));
const Benefits = lazy(() => import("@/components/Benefits").then(m => ({ default: m.Benefits })));
const CTA = lazy(() => import("@/components/CTA").then(m => ({ default: m.CTA })));
const BottomCTA = lazy(() => import("@/components/BottomCTA").then(m => ({ default: m.BottomCTA })));
const Footer = lazy(() => import("@/components/Footer").then(m => ({ default: m.Footer })));
const ExitIntentModal = lazy(() => import("@/components/ExitIntentModal").then(m => ({ default: m.ExitIntentModal })));

const Index = () => {
  return (
    <div className="min-h-screen">
      <Suspense fallback={null}>
        <ExitIntentModal />
      </Suspense>
      <Helmet>
        <title>Agents Capital — Get Paid at Exchange, Not Completion</title>
        <meta name="description" content="We buy UK estate agent commission at exchange. Same-day offers, paid within 24 hours of exchange. No upfront costs." />
        <meta property="og:title" content="Agents Capital — Get Paid at Exchange, Not Completion" />
        <meta property="og:description" content="We buy UK estate agent commission at exchange. Same-day offers, paid within 24 hours of exchange." />
        <meta property="og:url" content="https://agentscapital.co.uk/" />
        <link rel="canonical" href="https://agentscapital.co.uk/" />
      </Helmet>
      <Header />
      <main>
        <Hero />
        <Suspense fallback={<div className="min-h-[200px]" />}>
          <AboutSection />
          <HowItWorks />
          <Benefits />
          <CTA />
          <BottomCTA />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
